import React from "react";
//Style
import { Container, Img } from "./style";
//Component
import Home from "./Home";

const JumBotron = () => {
  return (
    <Container>
      <Img src="https://bonnadona-public.s3.amazonaws.com/assets/banner.svg" />
    </Container>
  );
};
export default JumBotron;
